export type State = "connected" | "pending"
export type getStateRespone = {
    state: State
    color: string
    fullscreen: boolean
    headerText: string
}
export type Config = {
    mode?: 'sidebar' | 'fullscreen'
    popupHeight?: string
    allowBackgroundScroll?: boolean
    headerText?: string
    color?: string
    botIcon?: string
    metadata?: {
        [key: string]: any
    },
    disableAttachments?: boolean
    disableInput?: boolean
    disableReset?: boolean
    externalUserId: string
}

export type Events = "created" | "destroyed" | "messageReceived" | "messageSent" | "configUpdated" | "stateChanged"

export interface FxoMessenger {
    sendMessage(text: string, metadata?: any): boolean
    setConfig(config: Config): boolean
    getState(): getStateRespone
    create(): void
    destroy(): boolean
    toggle(): boolean
    on(event: Events, callback: (data: any) => void): void
    removeListeners(eventName?: string): void
}

declare global {
    interface Window {
        FxoMessenger: FxoMessenger
        flowxoReady: CallableFunction
    }
}

let fxoPromise: Promise<FxoMessenger> | null = null;

const initFxoMessenger = (): Promise<FxoMessenger> => {
  if (fxoPromise) return fxoPromise;

  fxoPromise = new Promise<FxoMessenger>((resolve, reject) => {
    window.flowxoReady = function () {
      resolve(window.FxoMessenger);
    };
    const script = document.createElement("script");
    script.src = `https://widget.flowxo.com/embed.js?callback=flowxoReady`;
    script.setAttribute(
      "data-fxo-widget",
      "eyJ0aGVtZSI6IiMxMDQ3N2QiLCJ3ZWIiOnsiYm90SWQiOiI2NGU0YjRlMjEyMzAzNzAwM2U3MGI5MjkiLCJ0aGVtZSI6IiMxMDQ3N2QiLCJsYWJlbCI6IkRvbmEgRGFsdmEifSwid2VsY29tZVRleHQiOiJFc3TDoSBjb20gZMO6dmlkYXM/In0="
    );
    script.async = true;
    script.defer = true;
    script.addEventListener("error", reject);
    document.head.appendChild(script);
  });

  return fxoPromise;
};
/*
const fxoPromise = new Promise<FxoMessenger>((resolve, reject) => {
    window.flowxoReady = function () {
        resolve(window.FxoMessenger)
    }
    const script = document.createElement('script')
    script.src = `https://widget.flowxo.com/embed.js?callback=flowxoReady`
    script.setAttribute('data-fxo-widget', 'eyJ0aGVtZSI6IiMxMDQ3N2QiLCJ3ZWIiOnsiYm90SWQiOiI2NGU0YjRlMjEyMzAzNzAwM2U3MGI5MjkiLCJ0aGVtZSI6IiMxMDQ3N2QiLCJsYWJlbCI6IkRvbmEgRGFsdmEifSwid2VsY29tZVRleHQiOiJFc3TDoSBjb20gZMO6dmlkYXM/In0=')
    script.async = true
    script.defer = true
    script.addEventListener('error', reject)
    document.head.appendChild(script)

})
*/

export const setConfig = async (config: Config): Promise<boolean> => {
    const fxo = await initFxoMessenger();
    return fxo.setConfig(config)
}

export const sendMessage = async (text: string, metadata?: any): Promise<boolean> => {
    const fxo = await initFxoMessenger();
    return fxo.sendMessage(text, metadata)
}

export const getState = async (): Promise<getStateRespone> => {
    const fxo = await initFxoMessenger();
    return fxo.getState()
}

export const create = async (): Promise<void> => {
    const fxo = await initFxoMessenger();
    return fxo.create()
}

export const destroy = async (): Promise<boolean> => {
    const fxo = await initFxoMessenger();
    return fxo.destroy()
}
export const toggle = async (): Promise<boolean> => {
    const fxo = await initFxoMessenger();
    return fxo.toggle()
}

export default {
    setConfig,
    sendMessage,
    getState,
    create,
    destroy,
    toggle,
    async on(event: Events, callback: (data: any) => void): Promise<void> {
        const fxo = await initFxoMessenger()
        fxo.on(event, callback)
    },
    async removeEventListeners(eventName?: string): Promise<void> {
        const fxo = await initFxoMessenger()
        fxo.removeListeners(eventName)
    }
}